module.exports = __webpack_public_path__ + "img/pgd_a_10111.984bf026.png";